import React, { useState, useEffect, useCallback } from "react";
import {
  SearchMajor,
  SortAscendingMajor,
  SortDescendingMajor,
  SortMinor,
} from "@shopify/polaris-icons";
import moment from "moment";
import debounce from "lodash.debounce";
import callApi from "../../utils/apiCaller";
import { Row } from "reactstrap";
import parse from "html-react-parser";

import Swal from "sweetalert2";

import { Link as LinkRouter } from "react-router-dom";
import {
  Card,
  Badge,
  ResourceList,
  ResourceItem,
  Filters,
  ChoiceList,
  Pagination,
  Icon,
  TextStyle,
  Link,
  Button,
} from "@shopify/polaris";

import config from "../../config/config";
import { useSelector } from "react-redux";
import ExportOrders from "./ExportOrders";
import BannerHeader from "../Dashboard/BannerHeader";

const OrderTable = (props) => {
  const listStore = useSelector((state) => state.listStore);
  const dataSettings = useSelector((state) => state.dataSettings);
  const filterIndicator = useSelector((state) => state.filterIndicator);
  const [isLoading, setIsLoading] = useState(false);
  const [listOrders, setListOrders] = useState([]);
  const [optionStore, setOptionStore] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [searchRender, setSearchRender] = useState("");
  const [dateRange, setDateRange] = useState(["this_month"]);
  const [storeSelected, setStoreSelected] = useState([config.shop]);
  const [paymentSelected, setPaymentSelected] = useState([
    filterIndicator.payment,
  ]);
  const [sort, setSort] = useState({
    pattern: "created_at",
    direction: "desc",
  });
  const optionsDateRange = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "This month", value: "this_month" },
    { label: "Last month", value: "last_month" },
    { label: "Last 30 days", value: "30_days" },
    { label: "Last 60 days", value: "60_days" },
    { label: "Last 90 days", value: "90_days" },
  ];
  const [perPage, setPerPage] = useState([props.type === "latest" ? 10 : 25]);
  const optionsPerPage = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "75", value: 75 },
    { label: "100", value: 100 },
  ];

  const [statusSelected, setStatusSelected] = useState([
    filterIndicator.status,
  ]);
  const optionsStatus = [
    { label: "Completed", value: "1" },
    { label: "Pending", value: "0" },
    { label: "Over quota", value: "2" },
    { label: "No Account OR Invalid", value: "3" },
    { label: "No Tracking number", value: "-1" },
    { label: "No transaction id", value: "4" },
    { label: "Missing PayPal account", value: "6" },
    { label: "Invalid tracking number", value: "5" },
    { label: "Error", value: "total_err" },
    { label: "All", value: "all" },
  ];
  const optionsPayment = [
    { label: "Paypal", value: "paypal" },
    { label: "Stripe", value: "stripe" },
    { label: "Paypal & stripe", value: "paypal_stripe" },
    { label: "Other", value: "other" },
    { label: "All", value: "all" },
  ];

  useEffect(() => {
    let newOptionStore = [];
    let listStoreArr = [];
    for (let i = 0; i < listStore.length; i++) {
      let dataPush = { label: listStore[i].shop, value: listStore[i].shop };
      newOptionStore.push(dataPush);
      listStoreArr.push(listStore[i].shop);
    }
    setOptionStore(newOptionStore);
    if (
      listStoreArr.length > 0 &&
      JSON.stringify(listStoreArr) !== JSON.stringify(storeSelected)
    ) {
      console.log(listStore);
      setStoreSelected(listStoreArr);
    }
  }, [listStore.length]);

  useEffect(() => {
    if (props.storeSelected != undefined && props.storeSelected != "all") {
      console.log("cong2", typeof props.storeSelected);
      setStoreSelected([props.storeSelected]);
    }
  }, [props.storeSelected]);

  useEffect(() => {
    if (filterIndicator.type !== "init") {
      setPaymentSelected([filterIndicator.payment]);
    } else if (dataSettings.sync_stripe == "1") {
      setPaymentSelected(["paypal_stripe"]);
    }
  }, [dataSettings.sync_stripe, filterIndicator.payment]);

  useEffect(() => {
    console.log("get order");
    const getListOrders = (
      search,
      dateRange,
      status,
      store,
      payment,
      page,
      recordPerPage
    ) => {
      setIsLoading(true);

      let params = {
        search,
        date_range: dateRange[0],
        status: status[0],
        store: JSON.stringify(store),
        payment: payment[0],
        page: page - 1,
        recordPerPage: recordPerPage[0],
        sort: sort,
        action: "getListOrders",
      };

      callApi("get", params).then((res) => {
        if (res?.data?.listOrders && res?.data?.listOrders?.length) {
          res.data.listOrders.unshift({
            id: -1,
          });
        }
        // if (config.platform === "WOO_COMMERCE") {
        //   setDataSettings(res.data.dataSettings);
        // }
        setListOrders(res?.data?.listOrders);
        setTotalOrders(parseInt(res?.data?.totalOrders));
        setIsLoading(false);
      });
    };
    getListOrders(
      search,
      dateRange,
      statusSelected,
      storeSelected,
      paymentSelected,
      currentPage,
      perPage
    );
  }, [
    search,
    dateRange,
    currentPage,
    perPage,
    statusSelected,
    storeSelected,
    paymentSelected,
    sort,
  ]);

  const emptyStateMarkup = (
    <div className="resource-list-empty">
      <div className="resource-list-empty__icon">
        <Icon color="sky" source={SearchMajor} />
      </div>
      <div className="resour-list-empty__text">
        <TextStyle variation="subdued">No orders</TextStyle>
      </div>
    </div>
  );

  const handleStoreTagRemove = (value) => {
    if (storeSelected.length > 1) {
      let newListStore = [...storeSelected];
      newListStore.splice(value, 1);
      setStoreSelected(newListStore);
    }
  };

  const getAccountId = (value) => {
    if (value === "" || value === null) {
      return "No info";
    } else {
      return value;
    }
  };

  const resourceName = {
    singular: "order",
    plural: "orders",
  };

  const updateSort = (pattern) => {
    setSort((old) => ({
      pattern,
      direction:
        // eslint-disable-next-line no-nested-ternary
        old.pattern === pattern
          ? old.direction === "asc"
            ? "desc"
            : "asc"
          : "asc",
    }));
  };

  const filters = [
    {
      key: "dateRange",
      label: "Time Filter",
      filter: (
        <ChoiceList
          title="Time Filter"
          titleHidden
          choices={optionsDateRange}
          selected={dateRange}
          onChange={(value) => setDateRange(value)}
        />
      ),
      shortcut: true,
    },

    {
      key: "store",
      label: "Store",
      filter: (
        <ChoiceList
          allowMultiple
          title="Sync status"
          titleHidden
          choices={optionStore}
          selected={storeSelected}
          onChange={(value) =>
            value.length > 0 ? setStoreSelected(value) : null
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "status",
      label: "Sync status",
      filter: (
        <ChoiceList
          title="Sync status"
          titleHidden
          choices={optionsStatus}
          selected={statusSelected}
          onChange={(value) => setStatusSelected(value)}
        />
      ),
      shortcut: true,
    },
    {
      // onRemove: handleTaggedWithRemove,
      key: "payment",
      label: "Payment",
      filter: (
        <ChoiceList
          title="Sync status"
          titleHidden
          choices={optionsPayment}
          selected={paymentSelected}
          onChange={(value) => setPaymentSelected(value)}
        />
      ),
      shortcut: true,
    },
    {
      key: "perPage",
      label: "Per page",
      filter: (
        <ChoiceList
          title="Per page"
          titleHidden
          choices={optionsPerPage}
          selected={perPage}
          onChange={(value) => setPerPage(value)}
        />
      ),
      shortcut: true,
    },
  ];

  const appliedFilters = () => {
    const result = [];
    if (!isEmpty(dateRange))
      result.push({
        onRemove: () => setDateRange(["this_month"]),
        key: "dateRange",
        label:
          "Date range: " +
          optionsDateRange.find((option) => option.value == dateRange).label,
      });

    if (!isEmpty(storeSelected))
      if (optionStore.length > 0) {
        for (let i = 0; i < storeSelected.length; i++) {
          result.push({
            key: "store_" + i,
            label:
              i === 0
                ? "STORE: " +
                  optionStore.find(
                    (option) => option.value === storeSelected[i]
                  ).label
                : optionStore.find(
                    (option) => option.value === storeSelected[i]
                  ).label,
            onRemove: () => handleStoreTagRemove(i),
          });
        }
      }
    if (!isEmpty(paymentSelected))
      result.push({
        onRemove: () => setPaymentSelected(["paypal"]),
        key: "payment",
        label:
          "Payment: " +
          optionsPayment.find((option) => option.value == paymentSelected)
            .label,
      });
    if (!isEmpty(statusSelected))
      result.push({
        onRemove: () => setStatusSelected(["all"]),
        key: "status",
        label:
          "Sync status: " +
          optionsStatus.find((option) => option.value == statusSelected).label,
      });
    if (!isEmpty(perPage))
      result.push({
        onRemove: () => setPerPage([25]),
        key: "perPage",
        label:
          "Record per page: " +
          optionsPerPage.find((option) => option.value == perPage).label,
      });

    return result;
  };

  const debounceSetSearch = useCallback(
    debounce((callback, param) => callback(param), 400),
    []
  );

  const filterControl = (
    <Filters
      appliedFilters={appliedFilters()}
      queryValue={searchRender}
      filters={filters}
      onQueryChange={(value) => {
        const phoneRegEx = new RegExp("^[a-zA-Z0-9_.#.-]*$");
        if (!phoneRegEx.test(value)) {
          Swal.fire({
            icon: "warning",
            title: "Notice!",
            text: "Search content is not in the correct format",
            showCloseButton: true,
            showConfirmButton: false,
          });
        } else {
          setSearchRender(value);
          setCurrentPage(1);
          debounceSetSearch(setSearch, value);
        }
      }}
      onQueryClear={() => {
        setSearchRender(null);
        debounceSetSearch(setSearch, null);
      }}
      queryPlaceholder="Order name/Tracking number/Transaction ID"
    ></Filters>
  );

  const processTransactionId = (transactionId, paymentName) => {
    var res = transactionId.split(" ");
    let dataReturn = "";
    let paymentURL = "https://www.paypal.com/activity/payment/";
    if (paymentName.includes("stripe") || paymentName.includes("Stripe")) {
      paymentURL = "https://dashboard.stripe.com/payments/";
    }
    for (let i = 0; i < res.length; i++) {
      if (res[i] === "") {
        dataReturn = "---";
      } else {
        if (i !== res.length - 1) {
          dataReturn +=
            '<a target="_blank" class="Polaris-Link" target="" href="' +
            paymentURL +
            res[i] +
            '">' +
            res[i] +
            "</a>" +
            "<br/>";
        } else {
          dataReturn +=
            '<a target="_blank" class="Polaris-Link" target="" href="' +
            paymentURL +
            res[i] +
            '">' +
            res[i] +
            "</a>";
        }
      }
    }
    return dataReturn;
  };

  const renderItem = (order, _, index) => {
    return (
      <ResourceItem id={order.id}>
        {order.id === -1 ? (
          <div>
            <Row className="row-orders">
              <div style={{ width: "100%", display: "contents" }}>
                <div
                  className="vertical-center d-flex"
                  style={{ width: "80px" }}
                  onClick={() => updateSort("name")}
                >
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-left">
                      Order
                    </p>
                  </TextStyle>
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "name"
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={sort.pattern === "name" ? null : "skyLight"}
                  />
                </div>
                {listStore.length > 1 ? (
                  <div className="vertical-center" style={{ width: "200px" }}>
                    <TextStyle variation="strong">
                      <p className="text-truncate font-weight-bold text-left">
                        Store
                      </p>
                    </TextStyle>
                  </div>
                ) : null}
                <div
                  className="vertical-center d-flex"
                  style={{ width: "120px" }}
                >
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-center">
                      Payment
                    </p>
                  </TextStyle>
                </div>{" "}
                <div
                  className="vertical-center d-flex"
                  style={{ width: "200px" }}
                >
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-center">
                      Tracking Number
                    </p>
                  </TextStyle>
                </div>
                <div
                  className="vertical-center d-flex"
                  style={{ width: "150px" }}
                >
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-center">
                      Carrier
                    </p>
                  </TextStyle>
                </div>
                <div
                  className="vertical-center d-flex"
                  style={{ width: "160px" }}
                >
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-left">
                      Transaction Id
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "220px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-center">
                      Sync Status
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "200px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-left">
                      {config.platform !== "WOO_COMMERCE"
                        ? "Acc paid/synced"
                        : "Account synced"}
                    </p>
                  </TextStyle>
                </div>
                <div
                  className="vertical-center  d-flex"
                  style={{ width: "150px" }}
                  onClick={() => updateSort("created_at")}
                >
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left font-weight-bold">
                      Date
                    </p>
                  </TextStyle>
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "created_at"
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={sort.pattern === "created_at" ? null : "skyLight"}
                  />
                </div>
                <div
                  className="vertical-center d-flex"
                  style={{ width: "150px" }}
                  onClick={() => updateSort("add_tracking_at")}
                >
                  <TextStyle variation="strong">
                    <p className="text-truncate font-weight-bold text-center">
                      Synced at
                    </p>
                  </TextStyle>
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "add_tracking_at"
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={
                      sort.pattern === "add_tracking_at" ? null : "skyLight"
                    }
                  />
                </div>
              </div>
            </Row>
          </div>
        ) : (
          <div>
            <Row>
              <div
                className="vertical-center"
                style={{ width: "100%", display: "contents" }}
              >
                <div className="vertical-center" style={{ width: "80px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left">
                      {order.source === "shopify" ? (
                        <Link
                          external
                          url={
                            "https://" +
                            config.shop +
                            "/admin/orders/" +
                            order.order_id
                          }
                        >
                          {order.name}
                        </Link>
                      ) : (
                        <span>
                          {config.platform !== "WOO_COMMERCE" ? (
                            order.name
                          ) : (
                            <Link
                              external
                              url={
                                config.shop +
                                "/wp-admin/post.php?post=" +
                                order.order_id +
                                "&action=edit"
                              }
                            >
                              #{order.name}
                            </Link>
                          )}
                        </span>
                      )}
                    </p>
                  </TextStyle>
                </div>
                {listStore.length > 1 ? (
                  <div className="vertical-center" style={{ width: "200px" }}>
                    <TextStyle variation="strong">
                      <p className="text-truncate text-left">{order.shop}</p>
                    </TextStyle>
                  </div>
                ) : null}
                <div className="vertical-center" style={{ width: "120px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left">
                      <Badge
                        status={
                          order.add_tracking_status != -2 &&
                          order.payment_gateway_names != "manual_checked"
                            ? "info"
                            : ""
                        }
                      >
                        {" "}
                        {order.payment_gateway_names}
                      </Badge>
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "200px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left">
                      {order.tracking_number}
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "150px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left">
                      {order.tracking_company}
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "160px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left">
                      {parse(
                        processTransactionId(
                          order.transaction_id,
                          order.payment_gateway_names
                        )
                      )}
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "220px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-center">
                      {order.add_tracking_status === "1" ? (
                        <Badge status="success" progress="complete">
                          Completed
                        </Badge>
                      ) : null}
                      {order.add_tracking_status === "-1" ? (
                        <Badge status="warning">No Tracking Number</Badge>
                      ) : null}
                      {order.add_tracking_status === "-2" ? (
                        <Badge status="warning">Paid by other gateways</Badge>
                      ) : null}
                      {order.add_tracking_status === "2" ? (
                        <Badge status="warning">Over quota</Badge>
                      ) : null}
                      {order.add_tracking_status === "3" ? (
                        <Badge status="critical">No Account OR Invalid</Badge>
                      ) : null}
                      {order.add_tracking_status === "4" ? (
                        <Badge status="warning">Order no transaction id</Badge>
                      ) : null}
                      {order.add_tracking_status === "5" ? (
                        <Badge status="warning">Invalid Tracking Number</Badge>
                      ) : null}
                      {order.add_tracking_status === "6" ? (
                        <Badge progress="complete" status="critical">
                          No PayPal Account
                        </Badge>
                      ) : null}
                      {order.add_tracking_status === "0" ? (
                        <Badge status="info" progress="partiallyComplete">
                          Pending
                        </Badge>
                      ) : null}
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "200px" }}>
                  {config.platform !== "WOO_COMMERCE" ? (
                    <TextStyle variation="strong">
                      {order.add_tracking_status === "6" ? (
                        <p className="text-truncate text-left">
                          <TextStyle variation="negative">
                            Need to connect PayPal acc: <br />
                            <b>
                              {order.pay_pal_account_id !== "" ||
                              order.pay_pal_account_id !== null
                                ? order.pay_pal_account_id
                                : ""}
                            </b>
                          </TextStyle>
                        </p>
                      ) : (
                        <p className="text-truncate text-left">
                          {getAccountId(order.pay_pal_account_id) ===
                          getAccountId(order.add_tracking_account) ? (
                            getAccountId(order.pay_pal_account_id)
                          ) : (
                            <span>
                              {getAccountId(order.pay_pal_account_id)} <br />
                              {getAccountId(order.add_tracking_account)}
                            </span>
                          )}
                        </p>
                      )}
                    </TextStyle>
                  ) : (
                    <p className="text-truncate text-left">
                      {getAccountId(order.add_tracking_account)}
                    </p>
                  )}
                </div>
                <div className="vertical-center" style={{ width: "150px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left">
                      {moment(order.created_at).format("D MMM YYYY, hh:mm a")}
                    </p>
                  </TextStyle>
                </div>
                <div className="vertical-center" style={{ width: "150px" }}>
                  <TextStyle variation="strong">
                    <p className="text-truncate text-left">
                      {order.add_tracking_at === "0"
                        ? "---"
                        : moment
                            .unix(order.add_tracking_at)
                            .format("D MMM YYYY, hh:mm a")}
                    </p>
                  </TextStyle>
                </div>
              </div>
            </Row>
          </div>
        )}
      </ResourceItem>
    );
  };

  return (
    <Card>
      {listOrders.length > 0 && props.type !== "latest" ? (
        <ExportOrders
          search={search}
          dateRange={dateRange}
          store={storeSelected}
          status={statusSelected}
          payment={paymentSelected}
        />
      ) : null}
      <div className="d-inline-block w-100">
        <ResourceList
          resourceName={resourceName}
          items={listOrders}
          renderItem={renderItem}
          loading={isLoading}
          filterControl={props.type === "latest" ? null : filterControl}
          emptyState={emptyStateMarkup}
        />
        {props.type === "latest" ? null : (
          <div className="d-flex justify-content-center p-4">
            <Pagination
              label={
                totalOrders
                  ? `Showing ${(currentPage - 1) * perPage + 1} to ${Math.min(
                      currentPage * perPage,
                      totalOrders
                    )} of ${totalOrders} shipments`
                  : null
              }
              hasPrevious={currentPage > 1}
              onPrevious={() => {
                setCurrentPage((value) => value - 1);
              }}
              hasNext={currentPage < Math.ceil(totalOrders / perPage)}
              onNext={() => {
                setCurrentPage((value) => value + 1);
              }}
            />
          </div>
        )}
        {listOrders.length > 9 && props.type === "latest" ? (
          <div className="m-4">
            <LinkRouter
              to={{
                pathname: config.pathName + "/orders",
                search: "?" + config.urlParamsValue,
              }}
            >
              Show more orders
            </LinkRouter>
          </div>
        ) : null}
      </div>
    </Card>
  );
};

export default OrderTable;

function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else {
    return value === "" || value == null;
  }
}
